import { AdminApi } from 'stylemix-vue-admin'

export default class BookingsApi extends AdminApi {
  constructor(parameters) {
    super('bookings/sharing', parameters)
  }

  join(toId, bookingId) {
    return this.submit('post', `/${this.endpoint}/`, {
      origin_id: toId,
      booking_id: bookingId,
    })
  }
}
